import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';
import paths from './paths';
import DEFINES from '@/defines';

Vue.use (Router);

const router = new Router ({
  mode: 'history',
  base: '/',
  linkActiveClass: 'active',
  routes: paths,
});

router.beforeEach (async (to, from, next) => {
  // if (to.path.startsWith ('/login') == true) {
  //   console.log ('Calling reset because on login screen');
  //   store.dispatch ('resetAll');
  // }

  //which layout to use ?
  var oldLayout = store.getters['app/appLayout'];
  var newLayout = to.meta.layout || DEFINES.LAYOUT_AUTH;

  if (newLayout != oldLayout) {
    store.dispatch ('app/setAppLayout', {layout: newLayout}, DEFINES.USE_ROOT);
  }

  if(store.getters['auth/isUploadModeLogin'] && to.name != 'UploadLink'){
    return next ({
      path : `/company/${store.state.company.selected_company_id}/film/${store.state.auth.upload_link.film_id}/link/${store.state.auth.upload_link.id}`
    });
  }

  if (store.getters['app/isLoggedIn'] && to.path.startsWith ('/login')) {
    return next ({name: 'Companies'});
  }

  // if not Logged in move to LogIn Page
  if (
    to.matched.some (record => record.meta.public) != true &&
    !store.getters['app/isLoggedIn']
  ) {
    return next ({
      path: '/login',
      query: {
        redirect: to.fullPath, // FIXME: redirect user after login
      },
    });
  }

  if (
    to.name != 'UploadLink' &&
    to.path.startsWith ('/company') &&
    to.params.company_id != null &&
    to.params.company_id != store.getters['company/getSelected']
  ) {
    await store
      .dispatch ('company/switchSelectedCompanyId', {
        id: to.params.company_id,
      })
      .then (response => {
        return next ();
      })
      .catch (error => {
        //if not a valid company navigate to company dashboard
        return next ({name: 'Companies'});
      });
  }

  // Only super admin can access the SA Panel
  if (
    to.path.startsWith ('/admin') &&
    store.getters['app/isLoggedIn'] &&
    !store.getters['user/isSuperAdmin']
  ) {
    return next ({name: 'Companies'});
  }
  // if (to.name == 'Subscription') {
  //   var selectedCompany = store.getters['company/getSelectedCompany'];
  //   if (store.getters['company/isCompanySubscribed']) {
  //     var selectedCompany = store.getters['company/getSelectedCompany'];
  //     return next ({
  //       name: 'SubscriptionDashboard',
  //       params: {subscription_id: selectedCompany.subscription},
  //     });
  //   }
  //   if (!store.getters['plan/getPlans']) {
  //     await store.dispatch ('plan/getPlans', {}, DEFINES.USE_ROOT);
  //   }
  //   if (selectedCompany) {
  //     return next ({
  //       name: 'Plans',
  //       params: {company_id: selectedCompany.id},
  //     });
  //   }
  // }

  if (
    to.name == 'CompanyProfile' &&
    !store.getters['company/getCompanies'].length
  ) {
    return next ({path: '/companies'});
  }
  next ();
});

export default router;
